import { IPost } from '_interfaces/post.interface';
import { ISelectionItemMetadata } from '_interfaces/systemPost.types';
import { EventItem } from 'components/EventItem';
import FlagIcon from 'assets/icons/event-flag.svg';
import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import { isSelectionItemPost } from 'utils/systemPostHelpers';
import { useGetProjectSelectionItemsByIdQuery, ISelectionOption } from 'redux-store/api/selections';

interface SelectionItemPostProps {
  post: IPost;
  onClick?: () => void;
}

export const SelectionItemPost: React.FC<SelectionItemPostProps> = ({ post, onClick }) => {
  const isValidPost = post.systemMetadata && isSelectionItemPost(post.systemMetadata);
  const linkData = isValidPost
    ? (post.systemMetadata as ISelectionItemMetadata).linkData
    : null;
  const selectionItemId = linkData?.selectionItemId;

  const { data: selection } = useGetProjectSelectionItemsByIdQuery(
    { selectionId: Number(selectionItemId) },
    { skip: !selectionItemId, refetchOnMountOrArgChange: true }
  );

  const imageUrl = useMemo(() => {
    if (!selection?.options) return null;
    const selectedOption = selection.options.find(
      (opt: ISelectionOption) => opt.isSelected
    );
    const firstOption = selection.options[0];
    return selectedOption?.logo?.url || firstOption?.logo?.url || null;
  }, [selection]);

  if (!isValidPost || !linkData) {
    return null;
  }

  const { createdAt } = post;
  const { selectionName } = linkData;
  const displayName = selectionName || 'Selection Item';

  const nameSplit = post.createdBy?.displayName?.split(' ');
  const firstName = nameSplit?.[0] || '';
  const lastName = nameSplit?.[1] || '';
  const initials = `${firstName?.[0] || ''}${lastName?.[0] || ''}`;
  const text = 'added a comment';
  const date = `${dayjs(createdAt).format('ll')} / ${dayjs(createdAt).format('LT')}`;

  return (
    <EventItem.Root>
      <EventItem.Header
        firstName={firstName}
        lastName={lastName}
        initials={initials}
        date={date}
        avatar={post.createdBy?.avatarUrl}
        text={text}
      />
      <EventItem.Content>
        <EventItem.Row>
          <EventItem.Circle>
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={displayName}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
              />
            ) : (
              <FlagIcon />
            )}
          </EventItem.Circle>
          <EventItem.Column>
            <EventItem.Text fontWeight={500} text={displayName} />
          </EventItem.Column>
        </EventItem.Row>
        <EventItem.ActionButton onClick={onClick} />
      </EventItem.Content>
    </EventItem.Root>
  );
};
